export const corsproxy_api_key = "4e1b8894"
export const git_sha1 = "cb347bc0f69878371bee8ac72f8887df623e6ad2"
